import { Component } from '@theme/component';

/**
 * Scroll to top button component.
 * Shows/hides based on scroll threshold and handles smooth scroll to top.
 *
 * @extends Component
 */
export class ScrollToTopButton extends Component {
  static observedAttributes = ['threshold'];

  #threshold = 0;
  #rafScheduled = false;
  #lastHidden = true;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.handleScroll);

    this.#threshold = Number(this.getAttribute('threshold')) || 0;

    if (this.#threshold > 0) {
      window.addEventListener('scroll', this.checkVisibility, { passive: true });
      this.checkVisibility();
    } else {
      this.hidden = false;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.handleScroll);
    window.removeEventListener('scroll', this.checkVisibility);
  }

  handleScroll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  checkVisibility = () => {
    if (this.#rafScheduled) return;
    this.#rafScheduled = true;
    requestAnimationFrame(this.#updateVisibility);
  };

  #updateVisibility = () => {
    this.#rafScheduled = false;
    if (document.documentElement.hasAttribute('scroll-lock')) return;
    const shouldHide = window.scrollY < this.#threshold;
    if (shouldHide !== this.#lastHidden) {
      this.#lastHidden = shouldHide;
      this.hidden = shouldHide;
    }
  };
}

if (!customElements.get('scroll-to-top-button')) {
  customElements.define('scroll-to-top-button', ScrollToTopButton);
}